
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade-in-events",
      function () {
        return require("private-next-pages/trade-in-events.tsx");
      }
    ]);
  